import { Facebook, Instagram, Linkedin, LineChart } from "lucide-react";

export const PLATFORM_META = {
  facebook: { label: "Facebook", Icon: Facebook, color: "#1877F2" },
  instagram: { label: "Instagram", Icon: Instagram, color: "#E1306C" },
  linkedin: { label: "LinkedIn", Icon: Linkedin, color: "#0A66C2" },
  ga4: { label: "Google Analytics", Icon: LineChart, color: "#E8710A" },
};

export function PlatformIcon({ platform, className = "h-4 w-4", withColor = true }) {
  const meta = PLATFORM_META[platform];
  if (!meta) return null;
  const { Icon, color } = meta;
  return <Icon className={className} style={withColor ? { color } : undefined} />;
}

export function PlatformChip({ platform, className = "" }) {
  const meta = PLATFORM_META[platform];
  if (!meta) return null;
  return (
    <span
      data-testid={`platform-chip-${platform}`}
      className={`inline-flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-1 text-xs font-semibold text-foreground shadow-sm backdrop-blur ${className}`}
    >
      <PlatformIcon platform={platform} className="h-3.5 w-3.5" />
      {meta.label}
    </span>
  );
}
